import {
  AutocompleteInput,
  ReferenceInput,
  SelectInput,
  TextInput,
} from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";

const mutationInventoryWriteOffFilterList = (permissions) => {
  const defaultFilter = [
    <TextInput
      alwaysOn
      source="code"
      label="mine.label.receipt_no"
      resettable
      variant="outlined"
      sx={{ maxWidth: "200px" }}
    />,
    <MuiDatePickerInput
      alwaysOn
      source="start_date"
      variant="outlined"
      label="mine.label.start_date"
      maxDateSource="end_date"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="end_date"
      //FIXME: semua DateInput tidak bisa di tambah resettable
      // resettable
      variant="outlined"
      label="mine.label.end_date"
      minDateSource="start_date"
    />,
    <SelectInput
      source="type"
      alwaysOn
      variant="outlined"
      label="mine.label.type"
      resettable
      choices={[
        { id: 1, name: "mine.label.stocktake" },
        { id: 2, name: "mine.label.sample" },
        { id: 3, name: "mine.label.warehouse_broke" },
        { id: 4, name: "mine.label.transfer_between_depo" },
      ]}
    />,
    <TextInput
      alwaysOn
      source="delivery_note"
      resettable
      variant="outlined"
      label="mine.label.delivery_note"
      sx={{ maxWidth: "200px" }}
    />,
    <TextInput
      alwaysOn
      source="note"
      label="mine.label.note"
      resettable
      variant="outlined"
      sx={{ maxWidth: "200px" }}
    />,
  ];
  if (permissions && permissions.update_company) {
    defaultFilter.splice(
      1,
      0,
      <ReferenceInput
        alwaysOn
        source="company_id"
        reference="companies"
        sort={{ field: "companies.alias", order: "ASC" }}
      >
        <AutocompleteInput
          resettable
          optionText="alias"
          variant="outlined"
          label="mine.label.depo"
        />
      </ReferenceInput>
    );
  }
  return defaultFilter;
};
export default mutationInventoryWriteOffFilterList;
